module.exports = __webpack_public_path__ + "img/ecosystem_01_bitcoin.49da94c0.png";